import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { History } from "history";
import Spinner from "../../components/Spinner";
import { apiClient } from "../../App";

interface Props {
  history: History;
}

const StyledServices = styled.div`
  max-width: 600px;
  margin: 1rem auto;

  .loading {
    text-align: center;
  }

  .service-row {
    padding: 0.75rem 0.25rem;
    border-bottom: 1px solid ${props => props.theme.colors.gray2};

    &:last-child {
      border-bottom-style:none;
    }
  }
`;

const Services: React.FC<Props> = () => {

  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState<any[]>([]);

  const loadServices = async () => {
    const { data } = await apiClient.get<any>("/services");

    setServices(Object.keys(data || {}).map((key) => data[key]));
    setLoading(false);
  }

  useEffect(() => {
    loadServices();
  }, []);


  return (
    <StyledServices>
      {loading && <div className="loading"><Spinner />Retrieving service data...</div>}
      {!loading && <h2>{services.length} services</h2>}
      {services.map((service: any) => <div className="service-row" key={service.name}>{service.name} ({service.instances.length} instances)</div>)}
    </StyledServices>
  );
};

export default Services;
